import { gql } from '@apollo/client';

export const GET_PORTAL_SERVER_URL = gql`
  query GET_PORTAL_SERVER_URL($originatorId: ID!) {
    getPortalServerUrl(originatorId: $originatorId) {
      url
      args
    }
  }
`;
